export const currentRunSelector = ({ runs }) => (runs.runs.find(r => r.id === runs.selectedRunId))
